import * as React from "react";
const PreparednessIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#preparedness_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.146 37.645a1.665 1.665 0 0 0-2.354 0l-2.569 2.57-2.569-2.57A1.665 1.665 0 0 0 9.3 40l2.569 2.57-2.57 2.568a1.665 1.665 0 1 0 2.355 2.355l2.57-2.57 2.568 2.57a1.665 1.665 0 0 0 2.354-2.355l-2.569-2.569L19.147 40a1.665 1.665 0 0 0 0-2.354Zm-.689-14.985-5.483 5.483-2.152-2.153a1.665 1.665 0 0 0-2.355 2.355l3.33 3.33a1.665 1.665 0 0 0 2.355 0l6.66-6.66a1.665 1.665 0 0 0-2.355-2.355Zm26.984 3.675H27.127a2.498 2.498 0 0 0 0 4.995H45.44a2.497 2.497 0 1 0 0-4.995ZM18.457 8.508l-5.483 5.483-2.152-2.153a1.665 1.665 0 0 0-2.355 2.355l3.33 3.33a1.665 1.665 0 0 0 2.355 0l6.66-6.66A1.664 1.664 0 0 0 19.64 8a1.665 1.665 0 0 0-1.183.508Zm8.67 8.67H45.44a2.497 2.497 0 1 0 0-4.995H27.127a2.498 2.498 0 1 0 0 4.995Zm18.314 23.31H27.127a2.497 2.497 0 1 0 0 4.994H45.44a2.497 2.497 0 1 0 0-4.995Z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "preparedness_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default PreparednessIcon;